(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function isMobileFooter() {
      return window.innerWidth <= 900;
    }
  
    function closeAllAccordions() {
      document.querySelectorAll('.primary-footer-cols .title').forEach(function(title) {
        title.classList.remove('accordion-open');
        if (title.nextElementSibling && title.nextElementSibling.tagName === 'NAV') {
          title.nextElementSibling.style.display = 'none';
        }
      });
    }
  
    function openAccordion(title) {
      title.classList.add('accordion-open');
      if (title.nextElementSibling && title.nextElementSibling.tagName === 'NAV') {
        title.nextElementSibling.style.display = 'block';
      }
    }
  
    function toggleAccordion(e) {
      if (!isMobileFooter()) return;
  
      const title = e.currentTarget;
      const isOpen = title.classList.contains('accordion-open');
  
      closeAllAccordions();
  
      if (!isOpen) {
        openAccordion(title);
      }
    }
  
    // Set up event listeners
    function setupFooterAccordion() {
      document.querySelectorAll('.primary-footer-cols .title').forEach(function(title) {
        title.style.cursor = 'pointer';
        title.removeEventListener('click', toggleAccordion); // Prevent duplicate listeners
        title.addEventListener('click', toggleAccordion);
      });
    }
  
    // Reset navs on resize
    function handleResize() {
      if (!isMobileFooter()) {
        // Show all navs on desktop
        document.querySelectorAll('.primary-footer-cols nav').forEach(function(nav) {
          nav.style.display = '';
        });
        document.querySelectorAll('.primary-footer-cols .title').forEach(function(title) {
          title.classList.remove('accordion-open');
        });
      } else {
        // Hide all navs on mobile
        document.querySelectorAll('.primary-footer-cols nav').forEach(function(nav) {
          nav.style.display = 'none';
        });
        document.querySelectorAll('.primary-footer-cols .title').forEach(function(title) {
          title.classList.remove('accordion-open');
        });
      }
    }
  
    setupFooterAccordion();
    handleResize();
  
    window.addEventListener('resize', handleResize);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-about"] && !Shopify.designMode) return;
  try {
    
  $(".home-about .tab-nav span").click(function () {
    var tab = $(this).attr('id');
    
    $(".home-about .tab-nav span, .home-about .tab-wrap").removeClass('is-active');
    $(".home-about .tab-nav span#" + tab).addClass('is-active');
    $(".home-about .tab-wrap#" + tab).addClass('is-active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-personalistation"] && !Shopify.designMode) return;
  try {
    
$(".personaliseSlider menu").hover(function () {
  $(".personaliseSlider").toggleClass('is-hover');
});

$(".personaliseSlider menu").hover(function () {
  $(".personaliseSlider .rhs").toggleClass('is-hover');
});


$(".personaliseSlider menu a").hover(function () {
  var link_class = $(this).attr('class');

  $(".personaliseSlider .rhs a").removeClass('is-active');
  $(".personaliseSlider .rhs a." + link_class).addClass('is-active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews-2024"] && !Shopify.designMode) return;
  try {
    
  $(".press-triggers svg").hover(function () {
    $(".press-triggers svg").removeClass('active');
    $(this).addClass('active');
    $(".press-quote h2 span").text($(this).data("quote"));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-look"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    // Get stored grid preference with explicit default of 4
    const storedGrid = localStorage.getItem('lookbookGrid') ?? '4';

    // Set initial grid
    $('.look-grid').attr('data-cols', storedGrid);
    $(`.grid-btn[data-grid="${storedGrid}"]`).addClass('active');

    // Handle grid button clicks
    $('.grid-btn').on('click', function() {
      const cols = $(this).data('grid');

      // Update localStorage
      localStorage.setItem('lookbookGrid', cols);

      // Update grid
      $('.look-grid').attr('data-cols', cols);

      // Update active button state
      $('.grid-btn').removeClass('active');
      $(this).addClass('active');
    });

    function getLookModals() {
      return Array.from(document.querySelectorAll('.look-grid .modal'));
    }

    function loadLookModalImages(root) {
      if (!root) return;
      root.querySelectorAll('img[data-original]').forEach(function(img) {
        var hiRes = img.getAttribute('data-original');
        if (!hiRes) return;
        img.loading = 'eager';
        img.removeAttribute('loading');
        if (img.getAttribute('src') !== hiRes) {
          img.src = hiRes;
        }
        img.classList.remove('lazyload', 'lazy');
        img.classList.add('lazyloaded');
      });
      if (window.jQuery) {
        jQuery(root).find('img[data-original]').trigger('appear');
      }
    }

    function preloadAdjacentLookImages(currentId) {
      var all = getLookModals();
      var index = all.findIndex(function(modal) { return modal.id === currentId; });
      if (index > 0) loadLookModalImages(all[index - 1]);
      if (index < all.length - 1) loadLookModalImages(all[index + 1]);
    }

    var navigatingLooks = false;

    MicroModal.init({
      onShow: modal => {
        updateNavigationButtons(modal.id);
        document.body.classList.add('look-modal-open');
        loadLookModalImages(modal);
        requestAnimationFrame(function() {
          loadLookModalImages(modal);
        });
        preloadAdjacentLookImages(modal.id);
      },
      onClose: modal => {
        if (navigatingLooks) return;
        document.body.classList.remove('look-modal-open');
        setTimeout(() => {
          if (!navigatingLooks) document.body.classList.remove('look-modal-open');
        }, 100);
      },
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-micromodal-close',
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: true,
      awaitOpenAnimation: false,
      awaitCloseAnimation: false,
      debugMode: false
    });

    let canOpenModal = true;

    // Update modal close handler
    $(document).on('click', '.modal__close', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const modalId = $(this).closest('.modal').attr('id');
      MicroModal.close(modalId);

      // Force remove the class
      document.body.classList.remove('look-modal-open');

      setTimeout(() => {
        canOpenModal = true;
        // Double-check class removal
        document.body.classList.remove('look-modal-open');
      }, 100);
    });

    // Separate handler for overlay
    $(document).on('click', '.modal__overlay', function(e) {
      // Only close if clicking directly on the overlay
      if (e.target === this) {
        e.preventDefault();
        e.stopPropagation();
        const modalId = $(this).closest('.modal').attr('id');
        MicroModal.close(modalId);

        // Force remove the class
        document.body.classList.remove('look-modal-open');

        setTimeout(() => {
          canOpenModal = true;
          // Double-check class removal
          document.body.classList.remove('look-modal-open');
        }, 100);
      }
    });

    // Update touchend handlers
    $('.modal__close').on('touchend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const modalId = $(this).closest('.modal').attr('id');
      MicroModal.close(modalId);

      // Force remove the class
      document.body.classList.remove('look-modal-open');

      setTimeout(() => {
        canOpenModal = true;
        // Double-check class removal
        document.body.classList.remove('look-modal-open');
      }, 100);
    });

    $('.modal__overlay').on('touchend', function(e) {
      // Only close if touching directly on the overlay
      if (e.target === this) {
        e.preventDefault();
        e.stopPropagation();
        const modalId = $(this).closest('.modal').attr('id');
        MicroModal.close(modalId);

        // Force remove the class
        document.body.classList.remove('look-modal-open');

        setTimeout(() => {
          canOpenModal = true;
          // Double-check class removal
          document.body.classList.remove('look-modal-open');
        }, 100);
      }
    });

    // Add a backup cleanup for edge cases
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
        document.body.classList.remove('look-modal-open');
      }
    });

    // Add click handler for modal triggers with lazyload initialization
    $('[data-custom-open]').on('click', function(e) {
      if (!canOpenModal) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      canOpenModal = false; // Prevent double-clicks
      const modalId = $(this).attr('data-custom-open');
      MicroModal.show(modalId);
      canOpenModal = true; // Reset immediately after opening
    });

    function updateNavigationButtons(currentId) {
      const allModals = getLookModals();
      const currentIndex = allModals.findIndex(modal => modal.id === currentId);

      const prevButton = document.querySelector(`#${currentId} .modal-nav.prev`);
      const nextButton = document.querySelector(`#${currentId} .modal-nav.next`);

      // Remove any existing disabled classes
      prevButton.classList.remove('disabled');
      nextButton.classList.remove('disabled');

      // Add disabled class for first and last items
      if (currentIndex === 0) {
        prevButton.classList.add('disabled');
      }

      if (currentIndex === allModals.length - 1) {
        nextButton.classList.add('disabled');
      }
    }

    $(document).on('click', '.modal-nav', function(e) {
      e.preventDefault();
      // Don't proceed if button is disabled
      if ($(this).hasClass('disabled')) return;

      const direction = $(this).data('nav');
      const currentModal = $(this).closest('.look-grid .modal');
      const allModals = getLookModals();
      const currentIndex = allModals.findIndex(modal => modal.id === currentModal[0].id);

      let targetIndex;
      if (direction === 'prev') {
        targetIndex = Math.max(0, currentIndex - 1);
      } else {
        targetIndex = Math.min(allModals.length - 1, currentIndex + 1);
      }

      if (targetIndex !== currentIndex) {
        const targetModalId = allModals[targetIndex].id;
        navigatingLooks = true;
        MicroModal.close(currentModal[0].id);
        MicroModal.show(targetModalId);
        navigatingLooks = false;
        updateNavigationButtons(targetModalId);
        loadLookModalImages(allModals[targetIndex]);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendations"]) return;
  try {
    
  var handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    var url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  var productRecommendationsSection = document.querySelector('.product-recommendations');
  var observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
